module.exports = __webpack_public_path__ + "static/media/arrow1.f0586b93.svg";